import * as globals from '@wandb/weave/common/css/globals.styles';
import {hexToRGB} from '@wandb/weave/common/css/utils';
import {IconRunningRepeat} from '@wandb/weave/components/Icon';
import styled, {css} from 'styled-components';

export const Icon = styled(IconRunningRepeat)`
  width: 24px;
  height: 24px;
`;

export const IconContainer = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 7px;
`;

export const IconWrapper = styled.span<{
  $showAdminBanner?: boolean;
  $isOpen?: boolean;
}>`
  display: inline-block;
  height: 40px;
  cursor: pointer;
  border-radius: 4px;
  padding: 8px;
  background: transparent;
  &:hover {
    color: ${globals.WHITE};
    background: rgba(250, 250, 254, 0.12);
  }
  ${p =>
    p.$isOpen &&
    css`
      &&& {
        color: ${globals.WHITE};
        background: rgba(250, 250, 254, 0.16);
      }
    `}

  color: ${props =>
    props.$showAdminBanner ? hexToRGB(globals.WHITE, 0.5) : globals.MOON_500};

  &:focus-visible {
    outline: 2px solid rgba(0, 150, 173, 0.6);
  }
`;
